import * as types from '../actions/typeNames'
import {findElementByPropName} from '../services/service'

const InitialState = {    
    layout: {
        labelStyle: "inline", // inline | block
        textAlign: "left", // left | center | right
        borderRadius: 0,
        fieldBorderRadius: 0 
    },
    backgrounds: {
        color: "#EEF2F5",
        inputColor: "#DDE3EF"
    },
    fonts: {
        title: {
            font:{
                name:"rubik-bold"
            },
            size: 32,
            color: "#1B3444"
        },
        label: {
            font:{
                name:"rubik-bold"
            },
            size: 22,
            color: "#666666"
        },
        input: {
            font:{
                name:"rubik-bold"
            },
            size: 20,
            color: "#666666"
        },
        button: {
            font:{
                name:"rubik-bold"
            },
            size: 30,
            color: "#FFFFFF"
        }
    },
    submit:{
        alignment: "center", // left | center | right
        bgColor: "#5DADDE",
        borderRadius: 5        
    }
}



const design = (state = InitialState, action) => {
    switch(action.type){
        case types.CHANGE_ANY_VALUE:
            return {
                ...state,
                [action.propSector]:{
                    ...state[action.propSector],
                    [action.propName]: action.value
                }
            }
        case types.CHANGE_FONT_VALUES:
            return {
                ...state,
                fonts:{
                    ...state.fonts,
                    [action.propSector]:{
                        ...state.fonts[action.propSector],
                        [action.propName]: action.value
                    }                    
                }
            }
        case types.SET_SETTINGS:
        case types.SET_CONFIG:
            if (action.config !== null && action.config.design !== null){
                return {
                    ...action.config.design
                }
            }else{
                return{
                    ...state
                }
            }
        case types.RESET_SETTINGS:
            let defaultDesign = getNewDesign(InitialState)
            if (defaultDesign !== null) {
                return defaultDesign;
            } else {
                return {
                    ...InitialState
                }
            }
        case types.SELECT_TEMPLATE:
            let newDesign = getNewDesign(action.template.design)
            if(newDesign !== null){
                return newDesign;
            }else{
                return state  
            }          
                        
        default:            
            return {...state}       
    }
}

const getNewDesign = (design) => {
    let newDesign = null
    if(design != null){
        newDesign = {}
        for(let sector in design){
            if(sector === 'fonts'){
                newDesign.fonts = {}
                for (let font_sector in design.fonts) {
                    let selectedFont = window.ThemeFonts.find((font) => {
                        return design.fonts[font_sector].font.name && font.name.toLowerCase() === design.fonts[font_sector].font.name.toLowerCase()
                    })
                    newDesign.fonts[font_sector] = { 
                        ...design.fonts[font_sector],
                        ["font"]: {
                            ...selectedFont
                        }
                    }
                }
            }else{
                newDesign[sector] = {
                    ...design[sector]
                }
            }
        }
    }
    return newDesign;
}


export default design;